import {
  GET_ORG_GROUP_SELECT,
  GET_ORG_GROUP_MEMBERS,
  EMPLOYEE_GROUPS_PAGE,
  EMPLOYEE_GROUPS_PENDING,
  GET_ORG_GROUPS,
  FETCH_ORG_GROUP,
  ADD_ORG_GROUP,
  UPDATE_ORG_GROUP,
  DELETE_ORG_GROUP,
  BULK_ADD_ORG_GROUP_MEMBERS,
  BULK_REMOVE_ORG_GROUP_MEMBERS,
  CLEAR_ORG_GROUPS,
  ORG_GROUPS_PAGE,
  ORG_GROUPS_PENDING,
} from "constants/actions";
const initialState = {
  orgGroupsPage: [],
  groupList: [],
  orgGroupDetail: null,
  orgMembers: [],
  bulkAddResult: null,
  bulkRemoveResult: null,
  loading: false,
  error: null,
};

export default function groups(state = initialState, action) {
  switch (action.type) {
    case GET_ORG_GROUP_SELECT:
      return {
        ...state,
        loading: false,
        groupList: action.payload,
      };
    case GET_ORG_GROUP_MEMBERS:
      return {
        ...state,
        loading: false,
        orgMembers: action.payload,
        error: null,
      };
    // Org Group
    case GET_ORG_GROUPS:
      return {
        ...state,
        loading: false,
        orgGroupsPage: action.payload,
        error: null,
      };
    case ORG_GROUPS_PENDING:
      return { ...state, loading: true, error: null };
    case FETCH_ORG_GROUP:
      return {
        ...state,
        loading: false,
        orgGroupDetail: action.payload,
        error: null,
      };
    // The following cases are for non-paginated org group actions. If you only use paginated data, you can remove or refactor these as needed.
    case ADD_ORG_GROUP:
    case UPDATE_ORG_GROUP:
    case DELETE_ORG_GROUP:
    case CLEAR_ORG_GROUPS:
      return state;
    case BULK_ADD_ORG_GROUP_MEMBERS:
      return {
        ...state,
        loading: false,
        bulkAddResult: action.payload,
        error: action.payload.error || null,
      };
    case BULK_REMOVE_ORG_GROUP_MEMBERS:
      return {
        ...state,
        loading: false,
        bulkRemoveResult: action.payload,
        error: action.payload.error || null,
      };
    case ORG_GROUPS_PAGE:
      return { ...state, orgGroupsPage: action.payload };
    default:
      return state;
  }
}
